import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'psc-yearly-spendings',
  templateUrl: './yearly-spending.component.html',
})
export class YearlySpendingComponent implements OnChanges {
  @Input() solarCalculatorResult: YearlySpendingResult[];
  @Input() currency: string;
  @Input() smallTitle: boolean;

  currentYear: number = new Date().getFullYear();
  canGetLoan: boolean = false;
  ngOnChanges() {
    this.setColumns();
  }

  private setColumns() {
    if (this.solarCalculatorResult[0]?.spendingWithBanks === 0 || this.solarCalculatorResult.length === 0) {
      this.canGetLoan = false;
    } else {
      this.canGetLoan = true;
    }
  }
}
export interface YearlySpendingResult {
  realSpending: number | string;
  spendingWithSolar: number | string;
  spendingWithBanks: number | string;
}
